import { createSlice } from "@reduxjs/toolkit";
import {
  ValidationPredefinedData,
  ValidationStatusItem,
} from "./Types";

type ValidationStatusState = {
  list: ValidationStatusItem[];
  predefinedData: ValidationPredefinedData;
  status: {
    listLoading: boolean;
    predefinedLoading: boolean;
    addLoading: boolean;
    updateLoading: boolean;
    deleteLoading: boolean;
  };
};

const initialState: ValidationStatusState = {
  list: [],
  predefinedData: {
    partners: [],
    technologies: [],
    integrations: [],
  },
  status: {
    listLoading: false,
    predefinedLoading: false,
    addLoading: false,
    updateLoading: false,
    deleteLoading: false,
  },
};

const validationStatusSlice = createSlice({
  name: "validation_status",
  initialState,
  reducers: {
    setValidationStatusList: (state, action) => {
      state.list = action.payload;
    },
    setValidationStatusListLoading: (state, action) => {
      state.status.listLoading = action.payload;
    },
    setValidationPredefinedData: (state, action) => {
      state.predefinedData = action.payload;
    },
    setValidationPredefinedLoading: (state, action) => {
      state.status.predefinedLoading = action.payload;
    },
    setValidationAddLoading: (state, action) => {
      state.status.addLoading = action.payload;
    },
    setValidationUpdateLoading: (state, action) => {
      state.status.updateLoading = action.payload;
    },
    setValidationDeleteLoading: (state, action) => {
      state.status.deleteLoading = action.payload;
    },
  },
});

export const validationStatusSliceReducer = validationStatusSlice.reducer;
export const validationStatusSliceAction = validationStatusSlice.actions;

